import { FileJson, X } from 'lucide-react';

// Import JSON multi-fichiers : liste des fichiers sélectionnés (preview) + progression/résultats.
export default function JsonItemsSection({ items, importing, progress, onRemove, onClear }) {
    return (
        <>
            {/* Liste des fichiers sélectionnés avec preview */}
            {items.length > 0 && (
                <div style={{ marginTop: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                        <strong style={{ fontSize: '0.88em' }}>
                            {items.length} fichier{items.length > 1 ? 's' : ''} sélectionné{items.length > 1 ? 's' : ''}
                            {' '}— Total : {items.reduce((acc, i) => acc + i.preview.nbSujets, 0)} sujets,
                            {' '}{items.reduce((acc, i) => acc + i.preview.nbQuestions, 0)} questions
                        </strong>
                        {!importing && (
                            <button type="button" onClick={onClear}
                                className="admin-btn admin-btn--xs"
                                style={{ fontSize: '0.78em' }}>
                                Tout retirer
                            </button>
                        )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 240, overflowY: 'auto' }}>
                        {items.map((item, idx) => (
                            <div key={idx} style={{
                                background: 'var(--surface-2)',
                                border: '1px solid var(--border)',
                                borderRadius: 6,
                                padding: 8,
                                fontSize: '0.85em',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                            }}>
                                <FileJson size={16} style={{ flexShrink: 0 }} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.file.name}
                                    </div>
                                    <div style={{ fontSize: '0.82em', color: 'var(--text-muted)' }}>
                                        {item.preview.nbSujets} sujet{item.preview.nbSujets > 1 ? 's' : ''} · {item.preview.nbQuestions} questions · {(item.file.size / 1024).toFixed(1)} Ko
                                    </div>
                                </div>
                                {!importing && (
                                    <button type="button"
                                        onClick={() => onRemove(idx)}
                                        title="Retirer ce fichier"
                                        style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--danger, #ef4444)', padding: 4 }}>
                                        <X size={14} />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Progression et résultats par fichier */}
            {progress && progress.total > 0 && (
                <div style={{ marginTop: 8, padding: 8, background: 'rgba(124,58,237,0.1)', borderRadius: 6, fontSize: '0.85em' }}>
                    {importing
                        ? <>Import : <strong>{progress.current}/{progress.total}</strong>…</>
                        : <>Terminé : <strong>{progress.results.filter(r => r.ok).length}/{progress.total}</strong> ok</>}
                    {progress.results.length > 0 && !importing && (
                        <ul style={{ margin: '6px 0 0', paddingLeft: 18, fontSize: '0.85em' }}>
                            {progress.results.map((r, i) => (
                                <li key={i} style={{ color: r.ok ? 'inherit' : '#fca5a5' }}>
                                    <code>{r.filename}</code> {r.ok
                                        ? <span style={{ color: 'var(--text-muted)' }}>· {r.nbS} sujets, {r.nbQ} questions</span>
                                        : <span> · {r.error}</span>}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </>
    );
}
